<template>
    <div>
        <h1 class="display-heading mb-3">Dispensing and Payments</h1>
        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-sm table-hover">
                    <colgroup>
                        <col width="50" />
                        <col width="150" />
                        <col />
                        <col width="150" />
                        <col width="150" />
                        <col width="250" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Time In</th>
                            <th>Full Name</th>
                            <th>IC Number</th>
                            <th>Phone Number</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="consultations.length === 0">
                            <td
                                :colspan="columnsCount"
                                class="text-center font-italic"
                            >
                                {{
                                    isTableLoading ? "Loading Data" : "No Data"
                                }}
                            </td>
                        </tr>

                        <tr
                            v-for="(consultation, index) in consultations"
                            :key="index"
                        >
                            <th scope="row">
                                {{
                                    (pagination.currentPage - 1) *
                                        pagination.pageSize +
                                    index +
                                    1
                                }}
                            </th>

                            <td>
                                {{ consultation.timeIn }}
                            </td>
                            <td class="text-nowrap">
                                {{ consultation.patientName }}
                            </td>
                            <td>
                                {{
                                    consultation.patientIcNumber ? consultation.patientIcNumber : "-"
                                }}
                            </td>
                            <td class="text-nowrap">
                                {{ consultation.patientPhoneNumber }}
                            </td>
                            <td class="text-nowrap">
                                <button
                                    class="btn btn-primary btn-sm btn-primary-insv mr-2"
                                @click="dispense(consultation.clinicPaymentId)">
                                    Dispense and Payment
                                </button>
                                <button
                                    class="btn btn-danger btn-sm"
                                    @click="deletePaymentRequest(consultation.clinicPaymentId)">
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <pagination
                    v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition"
                >
                </pagination>

                <popup-modal ref="popupModalDeletePaymentQueue" :hasCloseButton="false" title="Delete Payment Queue">
                    <template slot="content">
                        <template v-if="isClinicAdmin">
                            <template v-if="!isDeleting">
                                <p>
                                    Are you sure you want to delete this payment queue?
                                </p>
                                <p>
                                    This action cannot be undone!
                                </p>
                            </template>
                            <template v-else>
                                <p>{{ deleteMessage }}</p>
                            </template>
                        </template>
                        <template v-else>

                        <p>Please login clinic administrator module to delete.</p>
                        </template>

                    </template>
                    <template slot="footer">
                        <button v-if="isClinicAdmin" type="button" class="btn btn-danger mr-2" @click="confirmDelete">Delete Payment Queue</button>
                        <button type="button" class="btn btn-secondary" @click="dismissModalDeletePaymentQueue">Cancel</button>
                    </template>
                </popup-modal>
            </div>
        </div>
    </div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'ClinicPatientCheckIn',
    'components': {
        pagination,
        popupModal
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isClinicAdmin () {
            return this.$store.state.user.userRole === 5;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getList();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'consultations': [],
            'isDeleting': false,
            'deleteMessage': null,
            'deletePaymentQueueId': null
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition =
                this.$refs.tableSection.getBoundingClientRect().top +
                window.scrollY -
                document.querySelector('.top-navigation').clientHeight;
        });

        this.getPayments();
    },
    'methods': {
        getPayments () {
            this.axios.get('Clinic/GetClinicPayments').then(({ data }) => {
                this.isTableLoading = false;
                let paymentList = data.data;

                this.consultations = paymentList.map((item) => {
                    let queue = item.queue;

                    return {
                        'clinicPaymentId': item.clinicPaymentId,
                        'timeIn': convertToUserReadableDateTime(
                            queue.createdTime
                        ),
                        'patientIcNumber': queue.patientIcNumber,
                        'patientName': queue.patientName,
                        'patientPhoneNumber': queue.patientPhoneNumber
                    };
                });
            });
        },
        dispense (clinicPaymentId) {
            this.$router.push({
                'name': 'clinic-payment-details',
                'params': {
                    'clinicPaymentId': clinicPaymentId
                }
            });
        },
        deletePaymentRequest (clinicPaymentId) {
            this.isDeleting = false;
            this.$refs.popupModalDeletePaymentQueue.show();
            this.deletePaymentQueueId = clinicPaymentId;
        },
        dismissModalDeletePaymentQueue () {
            this.$refs.popupModalDeletePaymentQueue.hide();
        },
        confirmDelete () {
            this.isDeleting = true;
            this.deleteMessage = 'Deleting payment queue... Please wait.';
            this.axios.delete('Clinic/DeletePaymentQueue', {
                'params': {
                    'clinicPaymentId': this.deletePaymentQueueId
                }
            }).then(() => {
                this.$refs.popupModalDeletePaymentQueue.hide();
            }).catch(() => {
                this.deleteMessage = 'Error deleting payment queue. Please retry.';
            }).finally(() => {
                this.getPayments();
            });
        }
    }
};
</script>
